import { render, staticRenderFns } from "./MatchingBoard.vue?vue&type=template&id=4fafb46b&scoped=true&lang=pug"
import script from "./MatchingBoard.vue?vue&type=script&lang=js"
export * from "./MatchingBoard.vue?vue&type=script&lang=js"
import style0 from "./MatchingBoard.vue?vue&type=style&index=0&id=4fafb46b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fafb46b",
  null
  
)

export default component.exports